import { PAID_MEDIA_MOCK_CURRENCY } from "../../data/paidMediaOverviewMockData";
import {
  formatOverviewAmount,
  formatOverviewCurrency,
  formatOverviewMultiplier,
  formatOverviewNumber,
  formatOverviewPct,
  formatOverviewUnitCost,
} from "../../utils/paidMediaOverviewFormat";
import type { PlatformReportValueFormat } from "./platformReportConfig";

export const PLATFORM_REPORT_CURRENCY = PAID_MEDIA_MOCK_CURRENCY;

export function formatPlatformReportValue(
  value: number | null | undefined,
  format: PlatformReportValueFormat
): string {
  switch (format) {
    case "money":
      return formatOverviewAmount(value, PLATFORM_REPORT_CURRENCY);
    case "unitCost":
      return formatOverviewUnitCost(value, PLATFORM_REPORT_CURRENCY);
    case "percent":
      return formatOverviewPct(value, 2);
    case "multiplier":
      return formatOverviewMultiplier(value);
    default:
      return formatOverviewNumber(value);
  }
}

export function formatPlatformReportAxis(
  value: number,
  format: PlatformReportValueFormat
): string {
  if (format === "multiplier") {
    return formatOverviewMultiplier(value, 0);
  }
  if (format === "percent") {
    return formatOverviewPct(value, 0);
  }
  if (format === "count") {
    return formatOverviewNumber(value);
  }
  return formatOverviewCurrency(value, PLATFORM_REPORT_CURRENCY);
}

export function platformReportChangePercent(
  current: number | null | undefined,
  previous: number | null | undefined
): number | undefined {
  if (
    current === null ||
    current === undefined ||
    previous === null ||
    previous === undefined ||
    previous === 0
  ) {
    return undefined;
  }
  return Math.round(((current - previous) / Math.abs(previous)) * 10000) / 100;
}
